module.exports = "//static.hsappstatic.net/LoginUI/static-1.15413/img/okta-logo.svg"